import React from 'react';
import { Route, Routes } from 'react-router-dom';
import App from '../App';
import Home from '../components/views/home/Home';
import { ROUTES_PATH } from './constants';

const AppRoutes = () => (
  <Routes>
    <Route path={ROUTES_PATH.ROOT} element={<App />}>
      <Route path={ROUTES_PATH.ROOT} element={<Home/>}/>
    </Route>
  </Routes>
);

export default AppRoutes;
